import Footer from "../../components/containers/Footer";
import { WhiteSpace } from "../../components/supports";
import { PlayerTime } from "../PlayerTime";
import { BR5A_Track } from "../BR5A_Track";
import { useState, useEffect } from "react";
import "./leaderboards.css";
import ContentButton from "../../components/buttons/ContentButton";


const UnchainedLeaderboards = () =>{
    const [times, setTimes] = useState([]);
    const [metric, isMetric] = useState(true);
    let tracks = [BR5A_Track(301,"Class D"),BR5A_Track(302,"Class C"),BR5A_Track(303,"Class B"),BR5A_Track(304,"Class A"),BR5A_Track(305,"Class S")]
    
    const getTimes = async () =>{
        try {
            const response = await fetch("http://localhost:5000/api/leaderboards/unchained");
            const data = await response.json();
            setTimes(data);
        } catch (error) {
                console.error("Failed to fetch:", error.message);
            return null;
        }
    }



    const setMetricSystem = () =>{
        isMetric(true);
    }
    const setImperialSystem = () =>{
        isMetric(false);
    }
    const convertToImperial = () =>{
        for(let i = 0; i < times.length; i++){
            //times[i].top_speed = times[i].top_speed / 0.621371;
        }
    }

    const convertSpecificToImperial = (value) =>{
            if(!metric){
                value = Math.round(value * 0.621371);
                 return value;
            }else{
                return value;
            }
    }

    let speedString = "km/h";
    if(!metric){
        speedString = "mph";
    }

    useEffect (() =>{
        getTimes();
    }, [times])

    return(
        <div id="main_wrapper">
        <header>
            <h1></h1>
            <nav>
            </nav>
        </header>

        <div id="main_container">
     
        <WhiteSpace height="50"/>

                
              
        </div>
        <div id="contents">
            <section>
                <article className="article-center header">
                    CLASS CUPS
                    
                </article>
                <WhiteSpace height="50"/>
                <div className="article-center">
                    ⚙️
                </div>
                <WhiteSpace height="10"/>
                <div className="article-center">
                <ContentButton buttonText={"km/h"} onClick={setMetricSystem}></ContentButton>
                <ContentButton buttonText={"mph"} onClick={setImperialSystem}></ContentButton>
                </div>
                <section className="leaderboards">
                    {tracks.map((track, trackId) => (
                        
                        <div className="leaderboard-object" key={trackId}>
                        
                        <WhiteSpace height="50"/>
                            <div >
                                <div className="track-header">{track.name}</div>
                                 <div>
                                 <div className="grid-container">
                                                    <div className="grid-position grid-element info">
                                                    🥇
                                                    </div>
                                                    <div className="grid-element info">
                                                        Driver
                                                    </div>
                                                    <div className="grid-element info">
                                                        Time
                                                    </div>
                                                    <div className="grid-element info">
                                                        Vehicle
                                                    </div>
                                                    <div className="grid-element info">
                                                        Max speed
                                                    </div>
                                               
                                                </div>
                                    {/* Filter and sort times by timer_value */}
                                    {times
                                        .filter((trackTime) => trackTime.track_id === track.index) // Filter by track_id
                                        .sort((a, b) => a.timer_value - b.timer_value) // Sort by timer_value
                                        .map((trackTime, trackTimeId) => (
                                         
                                                <div className="grid-container">
                                                    <div className="grid-position grid-element">
                                                        {trackTimeId+1}
                                                    </div>
                                                    <div className="grid-element">
                                                        {trackTime.user_name}
                                                    </div>
                                                    <div className="grid-element">
                                                        {trackTime.display_timer}
                                                    </div>
                                                    <div className="grid-element">
                                                        {trackTime.car_name}
                                                    </div>
                                                    <div className="grid-element">
                                                        {convertSpecificToImperial(trackTime.max_speed)} {speedString}
                                                    </div>
                                                 
                                                </div>
                                          
                                        ))}
                                </div>
                            </div>

                        </div>
                    ))}
                </section>
            </section>
        </div>
        <Footer/>
    </div>
    );
};

export default UnchainedLeaderboards;